import { Card } from "primereact/card";
const Home = () => {
  return (
    <div className="card">
      <Card title="Pagina incial">
        <div className="m-0">
          <div>Seja bem-vindo!</div>
        </div>
      </Card>
    </div>
  );
};

export default Home;
